export default __webpack_public_path__ + "static/media/archive_normal.96c625ce.svg";